import script from "./workflow-widget.vue?vue&type=script&lang=ts&setup=true"
export * from "./workflow-widget.vue?vue&type=script&lang=ts&setup=true"

import "./workflow-widget.vue?vue&type=style&index=0&id=230459bd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230459bd"]])

export default __exports__